// Mock data for UNITYPRO HOMES

export const companyInfo = {
  name: "UNITYPRO HOMES",
  tagline: "Developers Pvt. Ltd.",
  slogan: "खुशियों का नया address",
  managingDirector: "Vipin Yadav",
  designation: "Managing Director",
  phones: ["9910579770", "9205196614"],
  whatsapp: "9910579770",
  address: "1st Floor, Anil Singh Complex, Near MCD Toll Kapashera, Delhi",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.123!2d77.062!3d28.514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDMwJzUwLjQiTiA3N8KwMDMnNDMuMiJF!5e0!3m2!1sen!2sin!4v1234567890"
};

// Featured Plots
export const featuredPlots = [
  {
    id: 101,
    title: "Residential Plot – IMT Sohna",
    type: "plot",
    size: "100 Sq. Yds",
    dimensions: "30' x 30'",
    price: "₹12,00,000",
    ratePerGaj: "₹12,000 / gaj",
    location: "IMT Sohna, Gurgaon",
    roadWidth: "30' Wide Road",
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&h=600&fit=crop",
    features: ["Near IMT", "Good Investment", "Clear Title", "Gated Area"],
    status: "Available"
  },
  {
    id: 102,
    title: "Premium Plot – Sohna Gurgaon Road",
    type: "plot",
    size: "100 Sq. Yds",
    dimensions: "30' x 30'",
    price: "₹16,00,000",
    ratePerGaj: "₹16,000 / gaj",
    location: "Sohna–Gurgaon Road (ATA Area)",
    roadWidth: "33' Wide Road",
    image: "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?w=800&h=600&fit=crop",
    features: ["High Growth Area", "Main Road Access", "Approved Layout"],
    status: "Available"
  },
  {
    id: 103,
    title: "Residential Plot – Sector 59",
    type: "plot",
    size: "100 Sq. Yds",
    dimensions: "30' x 30'",
    price: "₹22,00,000",
    ratePerGaj: "₹22,000 / gaj",
    location: "Sector 59, Baharampur",
    roadWidth: "30' Wide Road",
    image: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&h=600&fit=crop",
    features: ["Sector Location", "Good Connectivity", "Ready to Registry"],
    status: "Available"
  },
  {
    id: 104,
    title: "Residential Plot – Salapur",
    type: "plot",
    size: "100 Sq. Yds",
    dimensions: "30' x 30'",
    price: "₹45,00,000",
    ratePerGaj: "₹45,000 / gaj",
    location: "Salapur, Delhi",
    roadWidth: "40' Wide Road",
    image: "https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=800&h=600&fit=crop",
    features: ["Delhi Location", "Prime Area", "High Appreciation"],
    status: "Available"
  },
  {
    id: 105,
    title: "Premium Plot – Maruti Kunj",
    type: "plot",
    size: "100 Sq. Yds",
    dimensions: "30' x 30'",
    price: "₹35,00,000",
    ratePerGaj: "₹35,000 / gaj",
    location: "Maruti Kunj, Gurgaon",
    roadWidth: "33' Wide Road",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop",
    features: ["Prime Gurgaon Area", "Gated Society", "Near Golf Course Road"],
    status: "Available"
  }
];

// Featured Homes
export const featuredHomes = [
  {
    id: 201,
    title: "Luxury 3BHK Villa",
    type: "home",
    size: "1800 Sq. Ft.",
    bedrooms: 3,
    bathrooms: 3,
    price: "₹85,00,000",
    location: "Kapashera, Delhi",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop",
    features: ["Modular Kitchen", "Car Parking", "Terrace", "Vastu Compliant"],
    status: "Ready to Move"
  },
  {
    id: 202,
    title: "Modern 2BHK Apartment",
    type: "home",
    size: "1200 Sq. Ft.",
    bedrooms: 2,
    bathrooms: 2,
    price: "₹52,00,000",
    location: "Near Dwarka, Delhi",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&h=600&fit=crop",
    features: ["Gated Society", "Power Backup", "Lift", "Gym & Club"],
    status: "Under Construction"
  },
  {
    id: 203,
    title: "Spacious 4BHK Independent Floor",
    type: "home",
    size: "2400 Sq. Ft.",
    bedrooms: 4,
    bathrooms: 4,
    price: "₹1,20,00,000",
    location: "Uttam Nagar, Delhi",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&h=600&fit=crop",
    features: ["Separate Entry", "Balconies", "Reserved Parking", "Prime Location"],
    status: "Ready to Move"
  },
  {
    id: 204,
    title: "Affordable 1BHK Flat",
    type: "home",
    size: "600 Sq. Ft.",
    bedrooms: 1,
    bathrooms: 1,
    price: "₹28,00,000",
    location: "Mohan Garden, Delhi",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&h=600&fit=crop",
    features: ["Perfect for First Home", "Metro Connectivity", "Security", "Water Supply"],
    status: "Ready to Move"
  }
];

// Combine all properties
export const allProperties = [...featuredPlots, ...featuredHomes];

// Services
export const services = [
  {
    title: "Residential Plots",
    description: "Premium plots with clear titles, approved layouts, and excellent connectivity to major highways.",
    icon: "MapPin"
  },
  {
    title: "Homes & Villas",
    description: "Ready-to-move and under-construction homes designed for modern living with all amenities.",
    icon: "Home"
  },
  {
    title: "Farmhouses",
    description: "Spacious farmhouse plots perfect for weekend getaways and agricultural investments.",
    icon: "Trees"
  },
  {
    title: "Commercial Shops",
    description: "Prime commercial properties in high-footfall areas for your business ventures.",
    icon: "Store"
  },
  {
    title: "Legal Assistance",
    description: "Complete documentation support and legal guidance for hassle-free property transactions.",
    icon: "FileCheck"
  },
  {
    title: "Property Management",
    description: "End-to-end property management services from registration to possession.",
    icon: "Settings"
  }
];

// Testimonials
export const testimonials = [
  {
    name: "Rajesh Kumar",
    location: "Delhi",
    text: "Excellent service! Vipin sir helped me find the perfect plot for my dream home. Highly recommended!",
    rating: 5
  },
  {
    name: "Priya Sharma",
    location: "Gurgaon",
    text: "Very professional team. The entire process was smooth and transparent. Thank you UNITYPRO HOMES!",
    rating: 5
  },
  {
    name: "Amit Verma",
    location: "Noida",
    text: "Best property dealer in Delhi! Clear documentation and genuine prices. Great investment opportunity.",
    rating: 5
  }
];

// Stats
export const stats = [
  { label: "Properties Sold", value: "500+" },
  { label: "Happy Clients", value: "1000+" },
  { label: "Years Experience", value: "10+" },
  { label: "Projects Completed", value: "50+" }
];
